import React, { useEffect } from 'react';
import { useIntercomNotifications } from '../hooks/useIntercomNotifications';
import IntercomNotificationToast from './IntercomNotificationToast';
import IntercomAnswerModal from './IntercomAnswerModal';
import useAuthStore from '../stores/authStore';

export function IntercomNotificationManager() {
  const { user, isAuthenticated } = useAuthStore();
  const canAnswerIntercom = isAuthenticated && (user?.canAnswerIntercom === true);
  const { isConnected } = useIntercomNotifications(canAnswerIntercom);

  useEffect(() => {
    if (canAnswerIntercom) console.log('[Intercom] WebSocket connected:', isConnected);
  }, [isConnected, canAnswerIntercom]);

  if (!canAnswerIntercom) return null;

  return (
    <>
      <IntercomNotificationToast />
      <IntercomAnswerModal />
    </>
  );
}

export default IntercomNotificationManager;
